import instance from "../config/axios";
import { url, base_apis } from "../config/url";


export const getHTMLCategoryList = ( data) => {
  return instance.post(`${base_apis.htmlCategoryList}`, data).then((res) => {
    return res;
  });
};

export const getHTMLGameListByCategory = (data) => {
  return instance.post(`${base_apis.htmlGamesList}`, data).then((res) => {
    return res;
  });
};


export const getHTMLGame = (data) => {
  return instance.post(`${base_apis.htmlGameGet}/${data}`).then((res) => {
    return res;
  });
};
export const updateView = (data) => {
  return instance.post(`${base_apis.htmlGameUpdateView}`, data).then((res) => {
    return res;
  });
};

